import React from "react";
import { Link } from "react-router-dom";

const ItemMenu = ({ item }) => {
  const [aberto, setAberto] = React.useState(false);

  return (
    <>
      {item.location && <Link to={item.location}>{item.nome}</Link>}
      {item.subItens && (
        <>
          <a onClick={() => setAberto(true)}>{item.nome}</a>
          <div className={aberto ? "aberto" : ""}>
            <a
              className="voltar"
              onClick={() => setAberto(false)}
              tabIndex="-1"
            >
              Voltar
            </a>
            {item.subItens.map((subItem, i) => (
              <ItemMenu key={i} item={subItem} />
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default ItemMenu;
